import { apiClientWithRefreshToken } from "@/api/apiClient";
import { PurchaseOrder } from "@/v2/types";

export default async function FindOnePurchaseOrder(
    id: string,
): Promise<PurchaseOrder> {
    const res = await apiClientWithRefreshToken({
        url: `/purchase-orders/${id}`,
        method: "GET",
    });

    return res.data;
}
